<div class="flex h-full min-h-0 flex-col gap-3">
  @if (hasScrollableViewport) {
    <div class="flex shrink-0 items-center">
      <div class="flex items-center gap-2 rounded-lg border border-line bg-card/95 px-2 py-1 shadow-sm backdrop-blur-sm">
        <button type="button" class="flex h-6 w-6 items-center justify-center rounded-md text-muted transition hover:bg-primary-bg hover:text-primary disabled:cursor-not-allowed disabled:opacity-35" [disabled]="!canMoveOlder" (click)="moveViewport('older')" aria-label="Show previous month" title="Previous month">
          <i class="pi pi-chevron-left text-[10px]" aria-hidden="true"></i>
        </button>
        <span class="min-w-[150px] text-center text-[10px] font-semibold text-dim">{{ viewportLabel }}</span>
        <button type="button" class="flex h-6 w-6 items-center justify-center rounded-md text-muted transition hover:bg-primary-bg hover:text-primary disabled:cursor-not-allowed disabled:opacity-35" [disabled]="!canMoveNewer" (click)="moveViewport('newer')" aria-label="Show next month" title="Next month">
          <i class="pi pi-chevron-right text-[10px]" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  }

  <div
    #chartContainer
    class="relative min-h-[240px] flex-1 overflow-hidden rounded-[8px] border border-line bg-chart"
  >
    @if (options) {
      <div
        echarts
        [options]="options"
        class="h-full w-full"
        (chartInit)="onChartInit($event)"
        (chartClick)="onChartClick($event)"
        (chartFinished)="onChartFinished()"
      ></div>
    }
    @for (target of clickTargets; track target.index) {
      <button
        type="button"
        class="absolute z-[2] cursor-pointer border-0 bg-transparent p-0 outline-none"
        [style.left.px]="target.left"
        [style.top.px]="target.top"
        [style.width.px]="target.width"
        [style.height.px]="target.height"
        [style.backgroundColor]="selectedIndex === target.index + viewportStart ? 'rgba(26, 174, 159, 0.08)' : 'transparent'"
        [attr.aria-label]="'Select ' + target.label"
        [attr.aria-pressed]="selectedIndex === target.index + viewportStart"
        (mouseenter)="showMonthTooltip(target.index)"
        (mouseleave)="hideMonthTooltip()"
        (click)="selectVisibleMonth(target.index)"
      ></button>
    }
  </div>

  <div class="shrink-0 overflow-auto rounded-[8px] border border-line bg-card">
    <table class="w-full min-w-[980px] table-fixed border-collapse text-left text-[12px]">
      <colgroup>
        <col style="width: 14.285714%" />
        <col style="width: 14.285714%" />
        <col style="width: 14.285714%" />
        <col style="width: 14.285714%" />
        <col style="width: 14.285714%" />
        <col style="width: 14.285714%" />
        <col style="width: 14.285714%" />
      </colgroup>
      <thead class="sticky top-0 z-10 bg-card">
        <tr class="border-b border-line text-[11px] uppercase text-muted">
          <th class="px-4 py-2 font-extrabold">Month</th>
          <th class="px-4 py-2 font-extrabold">Earliest Date</th>
          <th class="px-4 py-2 text-right font-extrabold">{{ metricPercentHeader }}</th>
          <th class="px-4 py-2 text-right font-extrabold">Revenue</th>
          <th class="px-4 py-2 text-right font-extrabold">NFI</th>
          <th class="px-4 py-2 text-right font-extrabold">EBITDA</th>
          <th class="px-4 py-2 text-right font-extrabold">Net Profit</th>
        </tr>
      </thead>
      <tbody>
        @for (row of tableRows; track row.earliestDate) {
          <tr
            class="border-b border-line/70 text-ink last:border-b-0"
            [class.bg-primary-bg]="row.selected"
          >
            <td class="px-4 py-2 font-semibold">{{ row.month }}</td>
            <td class="px-4 py-2 text-dim">{{ row.earliestDate }}</td>
            <td class="px-4 py-2 text-right font-semibold">{{ row.kpiPercent }}</td>
            <td class="px-4 py-2 text-right">{{ row.revenue }}</td>
            <td class="px-4 py-2 text-right">{{ row.nfi }}</td>
            <td class="px-4 py-2 text-right">{{ row.ebitda }}</td>
            <td class="px-4 py-2 text-right">{{ row.netProfit }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
